import React from "react";
import { useTranslation } from "react-i18next";
import { motion, useReducedMotion } from "framer-motion";
import { FiCheck, FiPackage, FiSun, FiUsers } from "react-icons/fi";
import * as D from "./Farms.desktop.styled";

const FEATURES = [
  { key: "feature1", icon: FiSun, accent: "green" },
  { key: "feature2", icon: FiPackage, accent: "blue" },
  { key: "feature3", icon: FiUsers, accent: "yellow" },
];

const FarmFeaturesDesktop = () => {
  const { t } = useTranslation();
  const reduceMotion = useReducedMotion();

  return (
    <D.FeaturesSection id="how-it-works">
      <D.Container>
        <D.FeaturesHeader>
          <D.SectionKicker>
            <FiCheck aria-hidden="true" style={{ marginRight: 6 }} />
            {t("farms.features.kicker", {
              defaultValue: "Why Dora e Fshatit",
            })}
          </D.SectionKicker>
          <D.SectionTitle>
            {t("farms.features.section_title", {
              defaultValue: "Why Choose Us?",
            })}
          </D.SectionTitle>
        </D.FeaturesHeader>

        <D.FeaturesGrid>
          {FEATURES.map((feat, index) => {
            const Icon = feat.icon;
            return (
              <D.FeatureCard
                key={feat.key}
                as={motion.div}
                $accent={feat.accent}
                initial={{ opacity: 0, y: reduceMotion ? 0 : 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: reduceMotion ? 0 : 0.5,
                  delay: reduceMotion ? 0 : index * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <D.FeatureIconTile $accent={feat.accent}>
                  <Icon aria-hidden="true" />
                </D.FeatureIconTile>
                <D.FeatureTitle>
                  {t(`farms.features.${feat.key}_title`)}
                </D.FeatureTitle>
                <D.FeatureText>
                  {t(`farms.features.${feat.key}_text`)}
                </D.FeatureText>
              </D.FeatureCard>
            );
          })}
        </D.FeaturesGrid>
      </D.Container>
    </D.FeaturesSection>
  );
};

export default FarmFeaturesDesktop;
